<template>
  <div class="hcp-tag-cell">
    <template v-if="tags.length">
      <el-popover
        v-if="tags.length > 1"
        placement="bottom-start"
        trigger="hover"
        popper-class="hcp-tag-popover"
        :open-delay="100"
      >
        <div class="all-tags">
          <div class="pop-title">All Tags <span>{{ tags.length }}</span></div>
          <div class="pop-grid">
          <div v-for="group in groupedTags" :key="group.id" class="pop-row">
            <span class="pop-label">{{ group.name }}</span>
            <div class="pop-chips">
              <span
                v-for="tag in group.values"
                :key="tag.id"
                class="hcp-tag-chip"
                :class="tag.color"
              >
                {{ tag.name }}
              </span>
            </div>
          </div>
          </div>
        </div>
        <div slot="reference" class="tag-trigger">
          <span class="hcp-tag-chip name" :class="visibleTag.color">{{ visibleTag.name }}</span>
          <span class="hcp-tag-chip more">+{{ restCount }}</span>
        </div>
      </el-popover>
      <span v-else class="hcp-tag-chip" :class="visibleTag.color">{{ visibleTag.name }}</span>
    </template>
    <span v-else>-</span>
  </div>
</template>

<script>
import { loadHcpTagCatalog, resolveHcpTags, groupHcpTags } from "@/utils/hcp-tag-catalog";

export default {
  name: "HcpTagCell",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    loadHcpTagCatalog(this.axios).catch(() => {});
  },
  computed: {
    tags() {
      return resolveHcpTags(this.value);
    },
    visibleTag() {
      return this.tags[0] || null;
    },
    restCount() {
      return Math.max(this.tags.length - 1, 0);
    },
    groupedTags() {
      return groupHcpTags(this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.hcp-tag-cell {
  display: flex;
  align-items: center;
  max-width: 100%;
  height: 23px;

  ::v-deep .el-popover__reference-wrapper {
    display: flex;
    align-items: center;
    max-width: 100%;
    min-width: 0;
  }
}

.tag-trigger {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  min-width: 0;
  height: 20px;
  cursor: pointer;
}

.hcp-tag-chip {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: 20px;
  line-height: 18px;
  border: 1px solid;
  border-radius: 3px;
  padding: 0 6px;
  font-size: 11px;
  white-space: nowrap;

  &.name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.more {
    flex: none;
  }

  &.red {
    background: #fff4f3;
    border-color: #f2aaa4;
    color: #d52b1e;
  }

  &.blue {
    background: #eef9fc;
    border-color: #9ed3e3;
    color: #0078a3;
  }

  &.green {
    background: #f0f9eb;
    border-color: #b3e19d;
    color: #4c9f28;
  }

  &.orange {
    background: #fdf6ec;
    border-color: #f3d19e;
    color: #c27e18;
  }

  &.more {
    background: #f4f4f5;
    border-color: #d3d4d6;
    color: #606266;
  }
}
</style>

<style lang="scss">
.hcp-tag-popover {
  width: max-content;
  max-width: 520px;

  .pop-title {
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 10px;

    span {
      color: #909399;
      font-weight: 400;
      margin-left: 4px;
    }
  }

  .pop-grid {
    display: grid;
    grid-template-columns: max-content minmax(0, 1fr);
    align-items: center;
  }

  .pop-row {
    display: contents;
  }

  .pop-label,
  .pop-chips {
    min-height: 32px;
    border-top: 1px solid #f0f1f3;
    padding: 4px 0;
  }

  .pop-label {
    font-size: 12px;
    color: #606266;
    font-weight: 600;
    white-space: nowrap;
    padding-right: 12px;
  }

  .pop-chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
  }

  .hcp-tag-chip {
    display: inline-block;
    height: 20px;
    line-height: 18px;
    border: 1px solid;
    border-radius: 3px;
    padding: 0 6px;
    font-size: 11px;
    white-space: nowrap;

    &.red {
      background: #fff4f3;
      border-color: #f2aaa4;
      color: #d52b1e;
    }

    &.blue {
      background: #eef9fc;
      border-color: #9ed3e3;
      color: #0078a3;
    }

    &.green {
      background: #f0f9eb;
      border-color: #b3e19d;
      color: #4c9f28;
    }

    &.orange {
      background: #fdf6ec;
      border-color: #f3d19e;
      color: #c27e18;
    }
  }
}
</style>
